import { IconDownload, IconEye } from "@tabler/icons-react";
import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";
import { api } from "@/lib/api";

interface StrategyAssetButtonProps {
  kind: "report" | "keywords";
  action: "preview" | "download";
  label: string;
  fileName: string;
}

export function StrategyAssetButton({ kind, action, label, fileName }: StrategyAssetButtonProps) {
  const [busy, setBusy] = useState(false);

  async function handleClick() {
    if (busy) return;
    const previewWindow = action === "preview" ? window.open("about:blank", "_blank") : null;
    if (previewWindow) previewWindow.opener = null;
    setBusy(true);
    try {
      const blob = await api.get(`strategy-assets/${kind}`).blob();
      const url = URL.createObjectURL(blob);
      if (action === "preview") {
        if (!previewWindow) {
          URL.revokeObjectURL(url);
          toast.error("浏览器阻止了预览窗口，请允许弹窗后重试。");
          return;
        }
        previewWindow.location.href = url;
      } else {
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        document.body.append(link);
        link.click();
        link.remove();
        window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
      }
    } catch {
      previewWindow?.close();
      toast.error("文件加载失败，请重试。");
    } finally {
      setBusy(false);
    }
  }

  return (
    <Button variant="outline" disabled={busy} onClick={() => void handleClick()}>
      {busy ? (
        <Spinner data-icon="inline-start" />
      ) : action === "preview" ? (
        <IconEye data-icon="inline-start" />
      ) : (
        <IconDownload data-icon="inline-start" />
      )}
      {busy ? "正在载入…" : label}
    </Button>
  );
}
